import axios from 'axios';
// axios.defaults.baseURL = 'http://46.18.107.104:8000/'
axios.defaults.baseURL = 'https://thevibro.by:8443/'
// axios.defaults.baseURL = 'http://127.0.0.1:8000/'
// axios.defaults.baseURL = 'http://192.168.1.149:8000/'
// axios.defaults.baseURL = 'http://shylin.ru:8000/'
// axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Token ${token}`
} else {
  delete axios.defaults.headers.common['Authorization']
}

export default axios;
